import { useState } from "react";
import { PackageCheck, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/apiClient";
import { Button } from "./ui/button";

// Admin action: push already-paid on-hold WooCommerce orders into Processing.
export default function PushOnHold() {
  const [busy, setBusy] = useState(false);
  const [confirming, setConfirming] = useState(false);
  const [last, setLast] = useState(null);

  const run = async () => {
    setBusy(true);
    setConfirming(false);
    try {
      const { data } = await api.post("/admin/woo/push-onhold");
      setLast(data);
      if (data.checked === 0) {
        toast.success("No on-hold orders to push — you're all caught up.");
      } else {
        toast.success(`Pushed ${data.updated} order${data.updated === 1 ? "" : "s"} to Processing (checked ${data.checked} on-hold).`);
      }
    } catch (e) {
      console.error("push-onhold failed", e);
      toast.error("Couldn't reach WooCommerce to update orders. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="card-soft rounded-2xl p-5 mb-6 flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-testid="push-onhold">
      <div className="flex items-start gap-4">
        <div className="w-11 h-11 rounded-xl flex items-center justify-center bg-[#c59b27]/15 text-[#8a681c] shrink-0">
          <PackageCheck className="w-5 h-5" />
        </div>
        <div>
          <h3 className="font-display font-bold text-base">Push paid orders through</h3>
          <p className="text-sm text-muted-foreground mt-0.5 max-w-md">
            Moves WooCommerce <strong>on-hold</strong> orders that were already paid via Attestly into <strong>Processing</strong> — so you don't collect payment manually and they count as sales.
          </p>
          {last && (
            <p className="text-xs text-emerald-700 mt-1" data-testid="push-onhold-result">
              Last run: updated {last.updated} of {last.checked} on-hold orders.
            </p>
          )}
        </div>
      </div>
      <div className="shrink-0">
        {confirming ? (
          <div className="flex items-center gap-2" data-testid="push-onhold-confirm">
            <Button onClick={run} disabled={busy} className="rounded-xl h-10 px-4" data-testid="push-onhold-yes">
              {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Yes, push them"}
            </Button>
            <Button variant="outline" onClick={() => setConfirming(false)} disabled={busy} className="rounded-xl h-10 px-4" data-testid="push-onhold-cancel">
              Cancel
            </Button>
          </div>
        ) : (
          <Button onClick={() => setConfirming(true)} disabled={busy} className="rounded-xl h-10 px-5" data-testid="push-onhold-btn">
            Push on-hold orders
          </Button>
        )}
      </div>
    </div>
  );
}
